"use client";

import { useMutation } from "@tanstack/react-query";
import type { IdentifyTopicsRequest } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { identifyTopics } from "../api/identifyTopics";

export default function useIdentifyTopicsMutation() {
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: IdentifyTopicsRequest) =>
      identifyTopics(accessToken, request),
  });
}
